import React from "react";
import styled from "styled-components";

interface UserImageProp {
  img?: string;
  title?: string;
  size?: number;
  firstname?: string;
  lastname?: string;
  username?: string;
}

function UserAvatar({
  img,
  title,
  username,
  firstname,
  lastname,
  size = 38,
}: UserImageProp) {
  return (
    <Avatar size={size}>
      {img ? (
        <Image size={size} src={img} />
      ) : (
        <Text style={{ fontSize: 12 }}>
          {console.log(username?.split(" "))}
          {username?.split(" ")[0].charAt(0) || ""}.
          {username?.split(" ")[1].charAt(0) || ""}
        </Text>
      )}
    </Avatar>
  );
}

const Avatar = styled.div<{ size: number }>`
  display: grid;
  place-items: center;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  border-color: ${(props) => props.theme.foreground};
  background: ${(props) => props.theme.subtleGrey};
  overflow: hidden;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
`;

const Image = styled.img<{ size: number }>`
  object-fit: cover;
  height: ${(props) => props.size}px !important;
  width: ${(props) => props.size}px !important;
`;

const Text = styled.div`
  color: ${(props) => props.theme.color};
  font-size: 10px;
  font-weight: 700;
  text-transform: capitalize;
`;

export default UserAvatar;
